/**
 * Help (API)
 *  Help関連のAPI
 */
import session from './session'
//import file from './file'


var uri = process.env.API_ENDPOINT

export default {

  createHelp (data){
    console.debug('***** Called createHelp *****')
    return session.post(uri + '/api/he/create_Help/',data)
  },

  getHelp (state){
    console.debug('***** Called getHelp *****')
    return session.get(uri + '/api/he/get_Help/',state)
  },

  updateHelp(data){
    console.debug('***** Called updateHelp *****')
    return session.post(uri + '/api/he/update_Help/', data)
  },

  deleteHelp (helpid) {
    console.debug('***** Called deleteHelp *****')
    return session.delete(uri + '/api/he/delete_Help/' + helpid + '/')
  },

  createHelpItem (data) {
    console.debug('***** Called createHelpItem *****')
    return session.post(uri + '/api/he/create_HelpItem/',data)
  },

  getHelpItem (state) {
    console.debug('***** Called getHelpItem *****')
    return session.get(uri + '/api/he/get_HelpItem/',state)
  },
 
  updateHelpItem(data){
    console.debug('***** Called updateHelpItem *****')
    return session.post(uri + '/api/he/update_HelpItem/', data)
  },

  deleteHelpItem (itemid) {
    console.debug('***** Called deleteHelpItem *****')
    return session.delete(uri + '/api/he/delete_HelpItem/' + itemid + '/')
  },

  updateHelpId(data){
    console.debug('***** Called updateHelpId *****')
    return session.post(uri + '/api/he/update_HelpId/', data)
  },

  updateHelpItemImage(data){
    console.debug('***** Called updateHelpItemImage *****')
    return session.post(uri + '/api/he/update_HelpItemImage/', data)
  },

  getHelpImage(state){
    console.debug('***** Called getHelpImage *****')
    return session.get(uri + '/api/he/get_HelpImage/', state)
  },

  /*tabLoading(state){
    return session.get(uri + '/api/he/tab_loading/', state)
  }*/
}


// WEBPACK FOOTER //
// ./src/api/help.js